export default "__VITE_ASSET__3d38dcb3__"